import React from "react";
import { useNavigate } from "react-router-dom";

const CityListButton = () => {

    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/cityListing`, { replace: true });
    }

    return (
        <>
        <button onClick={handleClick}>City Listing</button>
        </>
    )
}

export default CityListButton